import React, { useState, useEffect } from "react";
import "./Profile.css";
import url from "../../../Utility/URL/url";
import axios from "axios";
import Editor from "../../../Utility/textEditor/editor";
import { toast } from "react-toastify";
import Loader from "../../../Utility/loader/Loader";
import getUsernameFromSession from "../../../Utility/gettingInformation/getUsernameFromSession";
import authHeader from "../../../headerTokenUtility/auth.header";
import "react-toastify/dist/ReactToastify.css";

function Profile() {
  const currency = [
    { value: "USD", label: "USD" },
    { value: "EUR", label: "EUR" },
    { value: "GBP", label: "GBP" },
    { value: "JPY", label: "JPY" },
    { value: "INR", label: "Rs." },
  ];

  const [profileDetails, setProfileDetails] = useState(null);
  const [originalProfileDetails, setOriginalProfileDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [uploading, setUploading] = useState(false);

  const username = getUsernameFromSession();

  // ✅ Fetch Profile Details
  useEffect(() => {
    async function getProfileDetails() {
      try {
        const response = await axios.post(
          `${url.GET_PROFILE_DETAILS}?username=${username}`,
          {}, // body is empty
          { headers: authHeader() }
        );

        setProfileDetails(response.data);
        setOriginalProfileDetails(response.data);
      } catch (error) {
        console.error(error);
        toast.warning(
          "Technical Error while fetching the profile Details.. Please retry again!",
          { position: toast.POSITION.TOP_RIGHT }
        );
      } finally {
        setLoading(false);
      }
    }

    getProfileDetails();

    return () => {
      // console.log("Profile component unmounted");
    };
  }, [username]);

  // ✅ Form Handlers
  const handleChange = (event) => {
    let { name, value } = event.target;
    setProfileDetails((curr) => ({ ...curr, [name]: value }));
  };

  const handleAboutEditor = (content) => {
    setProfileDetails((curr) => ({ ...curr, about: content }));
  };
   const handleCompanyLogo = (event) => {
  const { value } = event.target;
  setProfileDetails((prev) => ({ ...prev, companyLogo: value }));
};

   const handleworkDescriptionShortEditor = (content) => {
    setProfileDetails(() => ({ ...profileDetails, workDescriptionShort: content }));
  };
  

  const handleShortDescription = (content) => {
    setProfileDetails((curr) => ({ ...curr, description: content }));
  };

  const handleCurrencyChange = (event) => {
    setProfileDetails((curr) => ({
      ...curr,
      currency: event.target.value,
    }));
  };

  // ✅ Update Profile
  const updateProfile = async () => {
    return axios.put(url.PUT_UPDATE_PROFILE_DETAILS, profileDetails, {
      headers: authHeader(),
    });
  };

  const handleCancelButton = () => {
    setProfileDetails(originalProfileDetails);
  };

  const handleValidation = () => {
    const { firstName, lastName, description, about, currency } =
      profileDetails || {};

    let errors = {};
    errors.firstName = firstName ? "" : "Enter First Name here..";
    errors.lastName = lastName ? "" : "Enter Last Name here...";
    errors.description = description
      ? description === "<p><br></p>"
        ? "Enter description here..."
        : ""
      : "Enter description here...";
    errors.about = about
      ? about === "<p><br></p>"
        ? "Enter about yourself here..."
        : ""
      : "Enter about yourself here...";
    errors.currency = currency ? "" : "Select your currency here..";

    return errors;
  };

  const handleUpdateButton = async () => {
    const validationErrors = handleValidation();
    setErrors(validationErrors);

    const hasErrors = Object.values(validationErrors).some((err) => err);

    // const handleUpdateButton = async () => {
  await toast.promise(
    updateProfile(),
    {
      pending: "Updating Profile...",
      success: "Profile updated successfully!",
      error: "Failed to update profile. Please try again later...",
    }
  );
// };

  };
  const [countries, setCountries] = useState([]);

 useEffect(() => {
  fetch("https://restcountries.com/v2/all?fields=name,alpha2Code")
    .then((res) => res.json())
    .then((data) => {
      const countryList = data.map((c) => ({
        name: c.name,         // "India"
        code: c.alpha2Code,   // "IN"
      }));
      countryList.sort((a, b) => a.name.localeCompare(b.name));
      setCountries(countryList);
      // console.log("Fetched countries:", countryList); // ✅ check in console
    })
    .catch((err) => console.error("Error fetching countries:", err));
}, []);



  // ✅ Profile Picture Upload Flow
  const getPresignedUrl = async () => {
    const res = await axios.post(
      url.PRESIGNED_URL,
      { username },
      { headers: authHeader() }
    );
    return res.data; // { imageUrl, preSignedUrl }
  };

  const uploadToS3 = async (file, preSignedUrl) => {
    await axios.put(preSignedUrl, file, {
      headers: { "Content-Type": file.type },
    });
  };

  const saveImageUrl = async (imageUrl) => {
    await axios.post(
      url.SAVE_PROFILE_IMAGE,
      { username, imageUrl },
      { headers: authHeader() }
    );

    setProfileDetails((prev) => ({ ...prev, profilePic: imageUrl }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const { imageUrl, preSignedUrl } = await getPresignedUrl();
      await uploadToS3(file, preSignedUrl);
      await saveImageUrl(imageUrl);

      toast.success("Profile picture updated!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      toast.error("Failed to upload profile picture");
    } finally {
      setUploading(false);
    }
  };
const handleDeleteProfilePic = async () => {
  try {
    await axios.post(
      url.SAVE_PROFILE_IMAGE,
      { username, imageUrl: "" }, // 👈 send empty string
      { headers: authHeader() }
    );

    setProfileDetails((prev) => ({ ...prev, profilePic: null }));
    toast.success("Profile picture removed!");
  } catch (err) {
    console.error(err);
    toast.error("Failed to remove profile picture");
  }
};
const [showAvatarModal, setShowAvatarModal] = useState(false);

const avatars = [
  "https://api.dicebear.com/7.x/adventurer/svg?seed=avatar1",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=avatar2",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=avatar3",
  "https://api.dicebear.com/7.x/adventurer/svg?seed=avatar4",
];
useEffect(() => {
  const handleScroll = () => {
    if (showAvatarModal) setShowAvatarModal(false);
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [showAvatarModal]);


  return (
    <div className="profile">
      <div className="header">
        <div className="header-title d-flex flex-row">
          <p className="text-start fs-1 fw-bold">Profile</p>
        </div>
      </div>
      <hr />

      <div className="main">
        {loading ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-4">
              {/* ✅ Profile Picture Section */}
              <div className="main-header">
                <div className="profile-photo text-center">
                  <img
                    key={profileDetails?.profilePic} // 👈 Forces React to reload when URL changes
                    src={
                      profileDetails?.profilePic ||
                      "https://w0.peakpx.com/wallpaper/979/89/HD-wallpaper-purple-smile-design-eye-smily-profile-pic-face-thumbnail.jpg"
                    }
                    alt="Profile"
                    className="img-thumbnail"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />

                  <div className="mt-2">
    {/* Upload Button */}
    <input
      type="file"
      accept="image/*"
      onChange={handleFileChange}
      disabled={uploading}
    />
    {uploading && <p>Uploading...</p>}

    {/* Delete Button */}
    {profileDetails?.profilePic && (
      <button
        className="btn btn-danger btn-sm mt-2"
        onClick={handleDeleteProfilePic}
      >
        Delete Profile Picture
      </button>
    )}
  </div>
  {!profileDetails?.profilePic && (
  <div className="mt-3">
    <button
      className="btn btn-primary"
      onClick={() => setShowAvatarModal(true)}
    >
      Choose Avatar
    </button>
  </div>
)}
{showAvatarModal && (
  <div className="modal-backdrop"  onClick={() => setShowAvatarModal(false)}>
    <div className="modal-content p-3 rounded shadow bg-white" onClick={(e) => e.stopPropagation()}>
      <h5>Select an Avatar</h5>
      <div className="d-flex flex-wrap gap-3 justify-content-center">
        {avatars.map((avatarUrl, i) => (
          <img
            key={i}
            src={avatarUrl}
            alt="avatar"
            className="img-thumbnail"
            style={{
              width: "80px",
              height: "80px",
              objectFit: "cover",
              cursor: "pointer",
            }}
            onClick={async () => {
              try {
                await axios.post(
                  url.SAVE_PROFILE_IMAGE,
                  { username, imageUrl: avatarUrl },
                  { headers: authHeader() }
                );
                setProfileDetails((prev) => ({
                  ...prev,
                  profilePic: avatarUrl,
                }));
                toast.success("Avatar set as profile picture!");
                setShowAvatarModal(false);
              } catch (err) {
                console.error(err);
                toast.error("Failed to set avatar");
              }
            }}
          />
        ))}
      </div>
      <div className="text-end mt-3">
        <button
          className="btn btn-secondary"
          onClick={() => setShowAvatarModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}


                </div>
              </div>

              {/* ✅ Form Section */}
              <form className="row row-cols-lg g-2 mt-2 p-1">
                {/* Username */}
                <div className="advisingbuddy-url">
                  <label>Advising Buddy URL</label>
                  <div className="input-group">
                    <div className="input-group-text">
                      <b>advisingbuddy.com/</b>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={profileDetails?.username || ""}
                      readOnly
                    />
                  </div>
                </div>

                {/* First & Last Name */}
                <div className="names row">
                  <div className="col-6">
                    <label>First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      value={profileDetails?.firstName || ""}
                      onChange={handleChange}
                    />
                    {errors.firstName && (
                      <span className="text-danger">{errors.firstName}</span>
                    )}
                  </div>

                  <div className="col-6">
                    <label>Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="lastName"
                      value={profileDetails?.lastName || ""}
                      onChange={handleChange}
                    />
                    {errors.lastName && (
                      <span className="text-danger">{errors.lastName}</span>
                    )}
                  </div>
                </div>

                 <div className="companyName">
                  
                  <div className="companyName">
  <label htmlFor="companyLogo">Company Logo (URL)</label>
  <input
    type="text"
    className="form-control"
    name="companyLogo"
    placeholder="https://logo.clearbit.com/twitter.com"
    value={profileDetails?.companyLogo || ""}
    onChange={handleCompanyLogo}
  />
</div>

                </div>
                <div className="short-description">
                  <label className="" for="inlineFormInputGroupUsername">
                    Short Description
                  </label>
                  <Editor
                    value={profileDetails ? profileDetails.description : ""}
                    onEditorChange={handleShortDescription}
                  />
                  {errors.description ? (
                    <span className="text-danger">{errors.description}</span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="location detail">
<div className="col-6">
                      <label className="" for="inlineFormInputGroupUsername">
                        state
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="state"
                        value={profileDetails ? profileDetails.state : ""}
                        onChange={handleChange}
                      />
                      {errors.state ? (
                        <span className="text-danger">{errors.state}</span>
                      ) : (
                        ""
                      )}
                    </div>
                   <div className="col-6">
  <label>Country</label>
  <div className="custom-select-wrapper">
    <select
      className="form-control custom-select"
      name="country" style={{paddingRight:"1.8rem"}}
      value={profileDetails.countryCode || ""}
      onChange={(e) => {
        const selected = countries.find(
          (c) => c.code === e.target.value
        );
        setProfileDetails({
          ...profileDetails,
          country: selected?.name || "",
          countryCode: selected?.code || "",
        });
      }}
    >
      <option value="">Select Country</option>
      {countries.map((c) => (
        <option key={c.code} value={c.code}>
          {c.name}
        </option>
      ))}
    </select>
  </div>
</div>

      

      {/* <div className="col-6">
        <label>Country Code</label>
        <input
          type="text"
          className="form-control"
          name="countryCode"
          value={profileDetails.countryCode || ""}
          readOnly
        />
      </div> */}

                </div>
                <div className="shortWorkDesc">
                   <label className="col-12" for="inlineFormInputGroupUsername">
                    Work Short Description
                  </label>
                  <Editor
                    value={profileDetails ? profileDetails.workDescriptionShort : ""}
                    onEditorChange={handleworkDescriptionShortEditor}
                  />
                  {errors.workDescriptionShort ? (
                    <span className="text-danger">{errors.workDescriptionShort}</span>
                  ) : (
                    ""
                  )}
                
                </div>
                {/* About */}
                <div className="about-yourself">
                  <label>About Yourself</label>
                  <Editor
                    value={profileDetails?.about || ""}
                    onEditorChange={handleAboutEditor}
                  />
                  {errors.about && (
                    <span className="text-danger">{errors.about}</span>
                  )}
                </div>

                {/* Currency */}
                <div className="select-currency">
                  <label>Select currency</label>
                  <select
                    className="form-control"
                    name="currency"
                    value={profileDetails?.currency || ""}
                    onChange={handleCurrencyChange}
                  >
                    <option value="">Select Currency</option>
                    {currency.map((curr) => (
                      <option key={curr.value} value={curr.value}>
                        {curr.label}
                      </option>
                    ))}
                  </select>
                  {errors.currency && (
                    <span className="text-danger">{errors.currency}</span>
                  )}
                  <span className="text-muted">
                    Want to change currency? Contact us at
                    support@advisingbuddy.com
                  </span>
                </div>

                {/* Social Links */}
                <div className="social-links">
                  <div className="social-links-title">
                    Add your accounts and display links on your page.
                  </div>

                  {[
                    "linkedInLink",
                    "twitterLink",
                    "youtubeLink",
                    "instagramLink",
                  ].map((field) => (
                    <div key={field} className="input-group mb-2">
                      <div className="input-group-text">
                        <b>{field.replace("Link", "")}</b>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        name={field}
                        value={profileDetails?.[field] || ""}
                        onChange={handleChange}
                      />
                    </div>
                  ))}
                </div>
              </form>

              {/* Buttons */}
              <div className="row mt-3">
                <div className="col-lg-12 d-flex justify-content-between">
                  <button
                    className="btn btn-lg btn-success"
                    onClick={handleUpdateButton}
                  >
                    Update
                  </button>
                  <button
                    className="btn btn-lg btn-secondary border-dark"
                    onClick={handleCancelButton}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div className="col-4"></div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
